import React, {Fragment} from "react";
import NsBtnBack from "../../components/buttons/NsBtnBack";
import PdfViewer from "./components/PdfViewer";
import ModalConfirm from "../../components/ModalConfirm";
import ModalUpdateDocumentoArchivio from "./components/documenti/ModalUpdateDocumentoArchivio";
import {getDataFormattata} from "../../utility/common";

export default function DettaglioDocumentoArchivioView({
                                                           documento,
                                                           isAdmin,
                                                           handlerModificaDocumento,
                                                           handlerEliminaDocumento,
                                                           showConfirmDelDocumento,
                                                           setShowConfirmDelDocumento,
                                                           eliminaDocumento,
                                                           showModalUpdateDocumento,
                                                           closeModalUpdateDocumento,
                                                           updateDocumentoOk,
                                                       }) {
    return (
        documento &&
        <Fragment>
            <ModalConfirm
                show={showConfirmDelDocumento}
                handleClose={() => setShowConfirmDelDocumento(false)}
                handleOk={() => {
                    eliminaDocumento();
                    setShowConfirmDelDocumento(false);
                }}
                testo={"Sicuro di voler eliminare il titolo: " + (documento.titolo) + "?"}
            />
            <ModalUpdateDocumentoArchivio
                documento={documento}
                show={showModalUpdateDocumento}
                handleClose={closeModalUpdateDocumento}
                submitOk={updateDocumentoOk}
            />
            <div className={'row'}>
                <div className={'col-md-2'}>
                    <NsBtnBack tipoClasse={"btn-dark"} />
                </div>
                <div className={'col-md-8'}>
                    <h4 className={"text-center"}>{`${documento.marca} ${documento.modello}`}</h4>
                </div>
                <div className={'col-md-2 text-end'}>
                    {
                        isAdmin &&
                        <Fragment>
                            <button
                                type={'button'}
                                className={'btn btn-dark btn-sm'}
                                data-toggle="tooltip" title="Modifica"
                                onClick={handlerModificaDocumento}
                            >
                                <i className="fas fa-edit"/>
                            </button>
                            <button
                                type={'button'}
                                className={'btn btn-dark btn-sm'}
                                data-toggle="tooltip" title="Elimina"
                                onClick={handlerEliminaDocumento}
                            >
                                <i className="fas fa-trash"/>
                            </button>
                        </Fragment>
                    }
                </div>
            </div>
            <hr className={"dropdown-divider"}/>
            <h5 className={"text-center mb-4"}>{`${documento.titolo}`}</h5>
            <div className={"mt-4 text-center"}>
                {
                    documento.content_type === 'application/pdf' ?
                    <PdfViewer documento={documento}/>
                        :
                        <img src={`data:${documento.content_type};base64, ${documento.contenuto}`}
                             className={"ns-foto-archivio-big"}/>
                }
            </div>
            <div className={"row g-1"}>
                <div className={"col-6 text-end fw-bold"}>
                    Titolo:
                </div>
                <div className={"col-6"}>
                    {documento.titolo || '-'}
                </div>
                {
                    documento.tipo && documento.tipo !== '' &&
                    <Fragment>
                        <div className={"col-6 text-end fw-bold"}>
                            Tipologia:
                        </div>
                        <div className={"col-6"}>
                            {documento.tipo || '-'}
                        </div>
                    </Fragment>
                }
                {
                    documento.soggetto && documento.soggetto !== '' &&
                    <Fragment>
                        <div className={"col-6 text-end fw-bold"}>
                            Soggetto proprietario:
                        </div>
                        <div className={"col-6"}>
                            {documento.soggetto || '-'}
                        </div>
                    </Fragment>
                }
                {
                    ((documento.data_doc && documento.data_doc !== '')
                        || (documento.anno_doc && documento.anno_doc !== '')) &&
                    <Fragment>
                        <div className={"col-6 text-end fw-bold"}>
                            Data:
                        </div>
                        <div className={"col-6"}>
                            {`${documento.anno_doc || (documento.data_doc ? getDataFormattata(documento.data_doc) : '-')} ${parseInt(documento.anno_circa) === 1 ? 'ca.' : ''}`}
                        </div>
                    </Fragment>
                }
                {
                    (documento.formato && documento.formato !== '') &&
                    <Fragment>
                        <div className={"col-6 text-end fw-bold"}>
                            Formato e caratteristiche materiali:
                        </div>
                        <div className={"col-6"}>
                            {documento.formato || '-'}
                        </div>
                    </Fragment>
                }
                <div className={"col-6 text-end fw-bold"}>
                    Note:
                </div>
                <div className={"col-6"}>
                    {documento.note || '-'}
                </div>
            </div>
        </Fragment>
    );

}